import ClipboardJS from 'clipboard/dist/clipboard.min';

const clipboard = new ClipboardJS('.js-clipboard');

const copyToClipboard = {
    init: () => {
        copyToClipboard.initTooltip();
        copyToClipboard.run();
    },

    initTooltip: () => {
        jQuery('.js-clipboard').tooltip({
            trigger: 'click',
            placement: 'bottom'
        });
    },

    run: () => {
        clipboard.on('success', function (e) {
            copyToClipboard.setTooltip(e.trigger, 'Zkopírováno');
            copyToClipboard.hideTooltip(e.trigger);
            // console.info('Action:', e.action);
            // console.info('Text:', e.text);
            // console.info('Trigger:', e.trigger);
        });
    },

    setTooltip: (btn, message) => {
        jQuery(btn).tooltip('hide')
            .attr('data-original-title', message)
            .tooltip('show');
    },

    hideTooltip: (btn) => {
        setTimeout(function () {
            jQuery(btn).tooltip('hide');
        }, 1000);
    },


}

export default copyToClipboard;
